import React from 'react';
import { Button } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { 
  clearProcedureCodes, 
  selectCurrentEstimate 
} from '../../../../../services/ContractService/contractEstimateSlice';

export const ClearButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const estimate = useAppSelector(selectCurrentEstimate);
  
  const hasProcedureCodes = (estimate?.procedureCodes?.length ?? 0) > 0;

  const handleClear = () => {
    dispatch(clearProcedureCodes());
  };

  return (
    <Button
      variant="outlined"
      startIcon={<ClearIcon />}
      onClick={handleClear}
      disabled={!hasProcedureCodes}
      sx={{
        borderColor: '#94a3b8',
        color: '#64748b',
        '&:hover': {
          borderColor: '#64748b',
          backgroundColor: '#f1f5f9',
        },
        textTransform: 'none',
        fontWeight: 500
      }}
    >
      Clear
    </Button>
  );
};
